import { render, staticRenderFns } from "./FormAggregateTipoRegistro.vue?vue&type=template&id=9528d688"
import script from "./FormAggregateTipoRegistro.vue?vue&type=script&lang=js"
export * from "./FormAggregateTipoRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports